'use client';

import { c as _c } from "react/compiler-runtime";
import { getENV } from '../../utils/env';
import { useConsentGatedInit } from '../hooks/useConsentGatedInit';
import { useMedalliaDefaultButton } from './hooks/use-medallia-default-button';
import './MedalliaScript.scss';
export const MedalliaLoaderV2 = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getENV();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    NEXT_PUBLIC_MEDALLIA_ID_US,
    NEXT_PUBLIC_MEDALLIA_ID_CA,
    NEXT_PUBLIC_LOCALE
  } = t0;
  const isCA = NEXT_PUBLIC_LOCALE === "en-CA";
  const scriptId = isCA ? NEXT_PUBLIC_MEDALLIA_ID_CA : NEXT_PUBLIC_MEDALLIA_ID_US;
  useMedalliaDefaultButton();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      src: `https://resources.digital-cloud.medallia.com/wdcus/${scriptId}/onsite/embed.js`,
      consentGroup: "C0002"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useConsentGatedInit(t1);
  return null;
};